module.exports = __webpack_public_path__ + "img/icme2026.8d8f970f.png";